module.exports = __webpack_public_path__ + "static/media/fahrenheit1.2fa69786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work/fahrenheit1.png
// module id = 106
// module chunks = 0